import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBlock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      fillRule="evenodd"
      d="M12.17 2.198C6.64 2.198 2.118 6.72 2.118 12.25c0 5.53 4.522 10.052 10.052 10.052 5.53 0 10.052-4.521 10.052-10.052 0-5.53-4.521-10.052-10.052-10.052ZM3.618 12.25c0-4.702 3.85-8.552 8.552-8.552s8.552 3.85 8.552 8.552-3.85 8.552-8.552 8.552-8.552-3.85-8.552-8.552Zm4.831-.75a.75.75 0 0 0 0 1.5h7.442a.75.75 0 0 0 0-1.5H8.449Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBlock;
